import { Component, ojs, app } from "modular-openscriptjs";

const h = app("h");

export default class Collapse extends Component {
	render(id, ...args) {
		return h.div({ class: "collapse", id: `${id}` }, ...args);
	}
}
